<ng-container *ngIf="!showCalendar">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</ng-container>
<div class="position-relative">
    <mat-calendar ngSkipHydration *ngIf="showCalendar" (selectedChange)="selectedChange($event)"
        [selected]="selectedRangeValue" [dateFilter]="dateFilter" #myCalendar></mat-calendar>
</div>